import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsPage.PopupXeroAccrualManualReport.FormPopupContent', {
    title: 'Accruals Manual Journal',
    descriptionPO:
        'The following manual journal will replicate the line items in the report excepting lines with null remaining balance. For foreign currency amounts, we will make adjustments using rates from the Purchase Order request.',
    descriptionBill:
        'The following manual journal will replicate the line items in the report. For foreign currency amounts, we will make adjustments using rates from the Bill request.',
    narrationFieldTitle: 'Narration',
    narrationFieldPlaceholder: 'Enter narration',
    dateFieldTitle: 'Date',
    dateFieldPlaceholder: 'Select the date',
    accrualAccountFieldTitle: 'Accrual Account',
    accrualAccountFieldPlaceholder: 'Enter accrual account',
    remainingBalance: 'Remaining balance',
    net: 'Net',
    gross: 'Gross',
    unknownAmountHandlingTypeTitle: 'How to handle line items when the remaining balance cannot be calculated?',
    unknownAmountHandlingTypeOptionExclude: 'Exclude them from the journal.',
    unknownAmountHandlingTypeOptionAdd:
        'Add a single line representing the total remaining balance of the entire Purchase Order containing the unquantifiable lines. This single line will not include an account or tracking categories.',
    learnMoreText: 'Learn more',
    createButtonTitle: 'Create',
});
